import { BehaviorSubject } from 'rxjs';
import { CoreLayout } from '../interfaces/core-layout';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private readonly _layoutSource: BehaviorSubject<CoreLayout>;
  private readonly _layout: CoreLayout = {
    isNotificationSidebarEnabled: false,
    isNavigationEnabled: true,
    isCookieDisclaimerEnabled: true,
    isDarkThemeEnabled: false,
  };

  constructor() {
    // Customer Portal only supports light theme (so far)
    // const themeSettings = localStorage.getItem("dark-theme");
    this._layout.isDarkThemeEnabled = false;

    this._layoutSource = new BehaviorSubject(this._layout);
  }

  public get currentLayout() {
    return this._layoutSource.asObservable();
  }

  public toggleNotificationPanel(): void {
    this._layout.isNotificationSidebarEnabled = !this._layout.isNotificationSidebarEnabled;
    this._layoutSource.next(this._layout);
  }

  public toggleTheme(): void {
    this._layout.isDarkThemeEnabled = !this._layout.isDarkThemeEnabled;
    this.updateTheme();
  }

  public useDarkMode(): void {
    this._layout.isDarkThemeEnabled = true;
    this.updateTheme();
  }

  public setTemporaryLayout(isNavigationEnabled: boolean, isCookieDisclaimerEnabled: boolean) {
    const layout = {
      isCookieDisclaimerEnabled,
      isNavigationEnabled,
      isNotificationSidebarEnabled: this._layout.isNotificationSidebarEnabled,
    } as CoreLayout;

    this._layoutSource.next(layout);
  }

  private updateTheme(): void {
    localStorage.setItem('dark-theme', JSON.stringify(this._layout.isDarkThemeEnabled));

    this._layoutSource.next(this._layout);
  }
}
